import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "ASSESS",
  title: defineMessage({
    id: "fig.learning.ASSESS.title",
    defaultMessage: `Percentage of students in primary education achieving at least a minimum proficiency level in reading`,
  }),
  caption: defineMessage({
    id: "fig.learning.ASSESS.caption",
    defaultMessage: `Differences in reading performance between countries are large, but the gender gap tends to be small.`,
  }),
  source: defineMessage({
    id: "fig.learning.ASSESS.source",
    defaultMessage: `UIS database`,
  }),
};
